(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initRoot = (root) => {
    if (root.dataset.hugwarmerReady === 'true') return;
    root.dataset.hugwarmerReady = 'true';

    const mainImage = root.querySelector('#hugwarmer-main-image');
    const thumbs = [...root.querySelectorAll('[data-hug-thumb]')];
    thumbs.forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        const next = button.dataset.hugThumb;
        if (!next || mainImage.src === next) return;
        thumbs.forEach((item) => item.classList.toggle('is-active', item === button));
        mainImage.classList.add('is-changing');
        const probe = new Image();
        probe.onload = () => {
          mainImage.removeAttribute('srcset');
          mainImage.src = next;
          mainImage.style.objectPosition = button.dataset.imagePosition || 'center center';
          mainImage.classList.remove('is-changing');
        };
        probe.onerror = () => mainImage.classList.remove('is-changing');
        probe.src = next;
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      thumbs.find((button) => button.dataset.galleryBlockId === event.detail?.blockId)?.click();
    });

    const buyPanel = root.querySelector('[data-hug-buy]');
    root.querySelectorAll('[data-scroll-to-hug-buy]').forEach((button) => {
      button.addEventListener('click', () => buyPanel?.scrollIntoView({
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
        block: 'start',
      }));
    });

    root.querySelectorAll('[data-hug-variant]').forEach((input) => {
      input.addEventListener('change', () => {
        root.querySelectorAll('[data-hug-variant]').forEach((item) => {
          item.closest('label')?.classList.toggle('is-selected', item.checked);
        });
        const name = root.querySelector('[data-hug-variant-name]');
        if (name) name.textContent = input.dataset.title || '';
        const variantImage = input.dataset.hugVariantImage;
        if (mainImage && variantImage) {
          mainImage.removeAttribute('srcset');
          mainImage.src = variantImage;
          mainImage.alt = `${input.dataset.title || '選択カラー'}のHUGWARMER`;
          thumbs.forEach((item) => item.classList.remove('is-active'));
        }
        root.querySelectorAll('[data-hug-price]').forEach((price) => {
          price.textContent = input.dataset.price || '';
        });
        const available = input.dataset.available === 'true';
        const availability = root.querySelector('[data-hug-availability]');
        if (availability) availability.textContent = available ? '販売中' : '在庫なし';
        const submit = root.querySelector('[data-product-submit]');
        const submitLabel = root.querySelector('[data-product-submit-label]');
        if (submit) submit.disabled = !available;
        if (submitLabel) submitLabel.textContent = available ? 'カートに追加する' : '売り切れ';
        root.ownerDocument.dispatchEvent(new CustomEvent('colulu:variant-change', {
          detail: {
            productId: root.dataset.productId,
            variant: {
              id: Number(input.value),
              available,
              price_formatted: input.dataset.price,
            },
          },
        }));
      });
    });

    root.querySelectorAll('[data-scene-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-scene-track]');
      const prev = carousel.querySelector('[data-scene-prev]');
      const next = carousel.querySelector('[data-scene-next]');
      const progress = carousel.querySelector('.hugwarmer-scenes__progress i');
      if (!track) return;

      const step = () => {
        const first = track.querySelector('figure');
        if (!first) return track.clientWidth * 0.8;
        return first.getBoundingClientRect().width + 20;
      };
      const update = () => {
        const max = Math.max(1, track.scrollWidth - track.clientWidth);
        const ratio = Math.min(1, Math.max(0, track.scrollLeft / max));
        if (progress) progress.style.width = `${Math.max(10, ratio * 100)}%`;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      };
      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      update();
    });

    const motionMedia = root.querySelector('.hugwarmer-motion-media');
    const motionToggle = root.querySelector('.hugwarmer-motion-toggle');
    let playing = false;
    const setMotion = (play) => {
      if (!motionMedia || !motionToggle) return;
      playing = play && !reduceMotion.matches;
      motionMedia.src = playing ? motionMedia.dataset.motionSrc : motionMedia.dataset.stillSrc;
      motionToggle.textContent = playing ? '停止' : '再生';
      motionToggle.setAttribute('aria-pressed', String(playing));
      motionToggle.disabled = reduceMotion.matches;
    };
    motionToggle?.addEventListener('click', () => setMotion(!playing));
    reduceMotion.addEventListener?.('change', () => setMotion(false));
    setMotion(false);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-hugwarmer-root]').forEach(initRoot);
  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
